/*
 * Copyright (c) 2026 Centrica.  All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * Date: 2026-10-29
 */
import type { Route } from '@angular/router';
import { provideInformes } from './informes-orquestador.service';
import type { CatalogoInformes } from './informes.model';

/** Ruta de la opcion «Informes» dentro de cada producto. */
export const INFORMES_PATH = 'informes/list';

/** Clave de la data de la ruta con el producto del lanzador. */
export const DATA_PRODUCTO_INFORMES = 'productoInformes';

/**
 * Ruta de la opcion «Informes» de un producto, transversal como el Centro de Tareas: la opcion
 * del menu resuelve igual en todos (`/layout/<producto>/informes/list`). El producto que ya tiene
 * informes entrega su catalogo, que se registra en el orquestador al entrar a la ruta.
 *
 * @param producto codigo del producto (el del catalogo)
 * @param catalogo catalogo de informes del producto, si ya los tiene
 * @returns la ruta
 */
export function rutaInformes(producto: string, catalogo?: CatalogoInformes): Route {
  return {
    path: INFORMES_PATH,
    // Bajo demanda, como el Centro de Tareas: no entra al bundle inicial.
    loadComponent: () =>
      import('./informes-pagina.component').then((m) => m.InformesPaginaComponent),
    providers: catalogo ? [provideInformes(catalogo)] : [],
    title: 'OPTIONS_REPORTS_LAUNCHER',
    data: {
      breadcrumb: 'OPTIONS_REPORTS_LAUNCHER',
      i18n: true,
      [DATA_PRODUCTO_INFORMES]: producto,
    },
  };
}
